// extracted by mini-css-extract-plugin
export default {"cameraName":"RedLight_cameraName__YOwCz"};